import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Doctype, Workflow, Metadata } from 'src/app/entities/invoices';
import { InvoicesService } from 'src/app/services/invoices/invoices.service';
import { LoginService, UserData, UserInfo } from 'src/app/services/login/login.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { EstereInvoicesComponent } from './estere-invoices/estere-invoices.component';
import { PassiveInvoicesComponent } from './passive-invoices/passive-invoices.component';
import { ConfigProps, ConfigServiceService } from 'src/app/services/config-service/config-service.service';
import { UTILS } from 'src/app/entities/Utils';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css']
})
export class InvoicesComponent implements OnInit {

  @ViewChild('passiveInvoices', { static: false }) passiveInvoices: PassiveInvoicesComponent | undefined;
  @ViewChild('estereInvoices', { static: false }) estereInvoices: EstereInvoicesComponent | undefined;

  innerWidth: number | undefined;
  
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  navigator: string = 'sidebar.fatture';
  selectedFile: File | undefined;
  loading: boolean = false;

  currentUser: any;

  caricamentoEstere: boolean = false;
  caricamentoPassive: boolean = false;
  caricamentoNSO: boolean = false;

  configProps: Doctype | undefined;

  userInfo: any;
  structureDocType: Doctype | undefined;
  structureWorkflowStates: Workflow[] | undefined;
  structureWorkflowPassiveStates: Workflow[] | undefined;
  advancedSearch: boolean = false;

  metadataStructure: Metadata[] | undefined;

  constructor(private invoicesService: InvoicesService, public router: Router,
    private toast: ToastService, private configService: ConfigServiceService, private loginService: LoginService) { }

  async ngOnInit(): Promise<void> {
    try {
      this.userInfo = await this.loginService.getUserInfo();
      this.currentUser = await this.loginService.getSessionUserInfo();
      //this.userInfo = JSON.parse(localStorage.getItem("einvuser") || "");
      this.configProps = new UTILS().deepCopy(await this.configService.getDocTypeAttiva());
      this.structureDocType = this.configProps as Doctype;
      //this.currentUser = JSON.parse(localStorage.getItem("einvuser") || "");
      /*let responseDoctype = await this.invoicesService.getDoctype(this.currentUser?.dms_user_id);
      if (responseDoctype.success) {
        this.structureDocType = responseDoctype.data as Doctype;*/
        this.structureDocType.metadata.sort(
          (a: Metadata, b: Metadata) => {
            const order = ['denominazione', 'datafattura', 'numerofattura'];
            const indexA = order.indexOf(((a.name).toLowerCase()).replace(" ", ""));
            const indexB = order.indexOf(((b.name).toLowerCase()).replace(" ", ""));
            if (indexA !== -1 && indexB !== -1) {
              return indexA - indexB;
            } else if (indexA !== -1) {
              return -1;
            } else if (indexB !== -1) {
              return 1;
            } else {
              return 0;
            }
          });
      /*}*/
    } catch(error: any) {
      this.toast.openToast(error.message, "error");
      this.loading = false;
  }

    //Recupero dei WorflowState
    /*let responseWorkflowState = await this.invoicesService.getWorkflowStates(this.currentUser?.dms_user_id);
    if (responseWorkflowState.success) {*/
    this.structureWorkflowStates = new UTILS().deepCopy(await this.configService.getWorkflowAttiva()) as Workflow[];
    this.structureWorkflowPassiveStates = new UTILS().deepCopy(await this.configService.getWorkflowPassiva()) as Workflow[];
    /*}*/

  }

  async ngOnDestroy() {
    this.invoicesService.initService();
  }


  openAdvancedSearch() {
    !this.advancedSearch;
  }

  addInvoice() {
    this.router.navigate(['main/invoices/new']);
  }


  async loadFile(event: any) {
    this.loading = true;
    try {
      if (this.currentUser!.abilitato == 2) {
        this.toast.openToastWithConfig(false, 1000, "L'utente � configurato in sola lettura", 'warning');
      } else {
        let file = (event.target.files as FileList)[0];
        let formData = new FormData();
        formData.append("file", file);
        let response = await this.invoicesService.uploadFile(this.currentUser!.user_id, formData);
        
        if (response.success) {
          try {
            let message = "Upload fatture :";
            if (response.data.totals != undefined)
              message += ' totali: ' + response.data.totals;
            if (response.data.importeds != undefined)
              message += ', importate : ' + response.data.importeds;
            this.toast.openToastWithConfig(false, 1000, message, 'success');
          } catch (e) {
            console.log(e);
            this.toast.openToastWithConfig(false, 1000, response.msg, 'success');
          }
        } else {
          if (response.msg != "") {
            this.toast.openToastWithConfig(false, 1000, response.msg, 'error');
          }
          for (let i = 0; i < response.error.errors.length; i++) {
            this.toast.openToastWithConfig(false, 1000, response.error.errors[i], 'error');
          }          
          
        }
        this.loading = false;
      }
    } catch (error) {
      this.loading = false;
    }
  }

  async loadInvoiceInConserva(event: any) {
    this.loading = true;
    try {
      if (this.currentUser!.abilitato == 2) {
        this.toast.openToastWithConfig(false, 1000, "L'utente � configurato in sola lettura", 'warning');
      } else {
        let file = (event.target.files as FileList)[0];
        let formData = new FormData();
        formData.append("file", file);
        let response = await this.invoicesService.uploadInConservazione(this.currentUser!.user_id, formData, 'conserva');
        if (response.success) {
          try {
            let message = "Upload fatture in conservazione:";
            if (response.data.totals != undefined)
              message += ' totali: ' + response.data.totals;
            if (response.data.importeds != undefined)
              message += ', importate : ' + response.data.importeds;
            this.toast.openToastWithConfig(false, 1000, message, 'success');
          } catch (e) {
            console.log(e);
            this.toast.openToastWithConfig(false, 1000, response.msg, 'success');
          }
        } else {
          if (response.msg != "") {
            this.toast.openToastWithConfig(false, 1000, response.msg, 'error');
          }
          for (let i = 0; i < response.error.errors.length; i++) {
            this.toast.openToastWithConfig(false, 1000, response.error.errors[i], 'error');
          }
        }
        this.loading = false;
      }
    } catch (error) {
      this.loading = false;
    }
  }

  async loadPInvoiceInConserva(event: any) {
    this.loading = true;
    try {
      if (this.currentUser!.abilitato == 2) {
        this.toast.openToastWithConfig(false, 1000, "L'utente � configurato in sola lettura", 'warning');
      } else {
        let file = (event.target.files as FileList)[0];
        let formData = new FormData();
        formData.append("file", file);
        let response = await this.invoicesService.uploadInPassiveConservazione(this.currentUser!.user_id, formData, 'conserva');
        if (response.success) {
          try {
            let message = "Upload fatture passive in conservazione:";
            if (response.data.totals != undefined)
              message += ' totali: ' + response.data.totals;
            if (response.data.importeds != undefined)
              message += ', importate : ' + response.data.importeds;
            this.toast.openToastWithConfig(true, 500, message, 'success');
          } catch (e) {
            this.toast.openToastWithConfig(true, 500, response.msg, 'success');
          }
        } else {
          if (response.msg != "") {
            this.toast.openToastWithConfig(true, 500, response.msg, 'error');
          }
          for (let i = 0; i < response.error.errors.length; i++) {
            this.toast.openToastWithConfig(true, 500, response.error.errors[i], 'error');
          }

        }
        if (this.passiveInvoices) this.passiveInvoices.ngOnInit();
        this.loading = false;
      }
    } catch (error) {
      this.loading = false;
    }
  }



  async loadNotificaInConserva(event: any) {
    this.loading = true;
    try {
      if (this.currentUser!.abilitato == 2) {
        this.toast.openToastWithConfig(false, 1000, "L'utente è configurato in sola lettura", 'warning');
      } else {
        let file = (event.target.files as FileList)[0];
        let formData = new FormData();
        formData.append("file", file);
        let response = await this.invoicesService.uploadInConservazione(this.currentUser!.user_id, formData, 'notifica');
        this.toast.openToastWithConfig(false, 1000, response.msg, response.success ? 'success' : 'error')
        this.loading = false;
      }
    } catch (error) {
      this.loading = false;
    }
  }


  loadEstere() {
    this.caricamentoEstere = true;
  }

  loadPassive() {
    this.caricamentoPassive = true;
  }

  loadNso() {
    this.caricamentoNSO = true;
  }

}
